<template>
  <v-container>
    <v-card>
      <v-card-title class="dark-background white--text">
        General Information
      </v-card-title>
      <v-card-text class="mt-6">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="city" label="City"></v-text-field>
            </v-col>
            <v-col cols="4" md="2">
              <v-text-field v-model="state" label="State"></v-text-field>
            </v-col>
            <v-col cols="8" md="4">
              <v-text-field v-model="zip" label="Zip"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="diagnosed"
                :items="['Yes', 'No']"
                label="Received Diagnosis"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="intervention"
                :items="['Yes', 'No']"
                label="Received Early Intervention"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="insurance"
                :items="['Yes', 'No']"
                label="Has Insurance"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="provider"
                label="Insurance Provider"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="goals"
                label="What are your desired goals?"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="orange" dark @click="save">
          <v-progress-circular
            v-if="saving"
            indeterminate
            color="white"
          ></v-progress-circular>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      city: null,
      diagnosed: null,
      goals: null,
      insurance: null,
      intervention: null,
      profileID: this.id,
      provider: null,
      saving: false,
      state: null,
      zip: null,
    };
  },
  computed: {
    ...mapGetters({
      profile: "profiles/getProfile",
    }),
  },
  methods: {
    ...mapActions({
      initProfile: "profiles/initProfile",
      updateProfile: "profiles/updateProfile",
    }),
    async save() {
      this.saving = true;
      await this.updateProfile({
        city: this.city,
        state: this.state,
        zip: this.zip,
        diagnosed: this.diagnosed,
        insurance: this.insurance,
        provider: this.provider,
        intervention: this.intervention,
        goals: this.goals,
        id: this.profileID,
      });
      this.saving = false;
      this.$router.push({ name: "profile", params: { id: this.profileID } });
    },
  },
  async mounted() {
    await this.initProfile(this.profileID);
  },
};
</script>
